import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedHTMLMessage } from 'react-intl'

export default class RadioInput extends Component {
  radioFieldCheck = (selected, value) => {
    if (Array.isArray(selected)) {
      return selected.includes(value)
    }
    return selected === value
  }

  render() {
    const {
      name,
      onBlur,
      onChange,
      value,
      label,
      containerClass,
      selected,
      id,
      required,
      'aria-required': ariaRequired,
      'aria-invalid': ariaInvalid,
      'aria-describedby': ariaDescribedBy,
    } = this.props

    // Generate a unique ID for the radio button
    // When multiple radio buttons share the same name, they need unique IDs
    const fieldId = id || `${name}-${value}`.replace(/\s+/g, '-').toLowerCase()
    const isRequired = required || ariaRequired

    return (
      <div className={`amd-check-container ${containerClass || ''}`}>
        <input
          type="radio"
          id={fieldId}
          name={name}
          checked={this.radioFieldCheck(selected, value)}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          required={isRequired}
          aria-required={isRequired}
          aria-invalid={ariaInvalid}
          aria-describedby={ariaDescribedBy}
        />
        <label className="form-check-label" htmlFor={fieldId}>
          <p>
            <FormattedHTMLMessage id={label} />
            {isRequired && (
              <span className="required-indicator" aria-hidden="true">
                *
              </span>
            )}
          </p>
        </label>
      </div>
    )
  }

  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
    containerClass: PropTypes.string,
    id: PropTypes.string,
    required: PropTypes.bool,
    'aria-required': PropTypes.bool,
    'aria-invalid': PropTypes.bool,
    'aria-describedby': PropTypes.string,
  }
}
